import React from "react";
import { Box, Button } from "@mui/material";
import GetAppIcon from "@mui/icons-material/GetApp";

const UnsupportedFilePreview = ({ fileUrl, fileName, classes }) => {
  return (
    <Box className={classes.unsupportedFile} textAlign="center" p={2}>
      <p>Cannot preview this file type.</p>
      <Button
        variant="contained"
        color="primary"
        startIcon={<GetAppIcon />}
        href={fileUrl}
        target="_blank"
        download={fileName || "file"}
      >
        Download File
      </Button>
    </Box>
  );
};

export default UnsupportedFilePreview;
